import { SearchRequest, SearchResponse } from '@weave/schema-gen-ts/dist/schemas/search/v1/service.pb';
import { Entity } from '@weave/schema-gen-ts/dist/shared/wsearch/v1/entity.pb';
import { useQuery, UseQueryOptions } from 'react-query';
import { getUser } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { SchemaSearch } from './service';

const queryKeys = {
  base: 'search',
  search: (request: SearchRequest) => [queryKeys.base, request],
};

export type SearchRequestParams = Partial<SearchRequest> & {
  query: string;
  entity: Entity[];
};

export const useSearch = (
  request: SearchRequestParams,
  options: UseQueryOptions<SearchResponse, unknown, SearchResponse>
) => {
  const { selectedLocationIds: locationIds, selectedOrgId: orgId } = useAppScopeStore();
  const user = getUser();
  const userId = user?.userID;
  const finalRequest = {
    fuzzy: true,
    fuzzyScoreThreshold: 0.75, // TODO: determine what this should be when I implement it
    locationIds,
    orgId,
    userId,
    ...request,
  };

  return useQuery({
    queryKey: queryKeys.search(finalRequest),
    queryFn: () => SchemaSearch.Search(finalRequest),
    ...options,
  });
};
